import { Input } from 'reactstrap'
import { CancelIcon, CheckMarkIcon, CrownIcon, DnDIcon } from '../../../common/icons'
import { IInfoGoPosition } from '../../../../types/infogo'
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import '../infogo-config.scss'
import useAuth from '../../../../hook/useAuth';

type PositionItemProps = {
    id: any
    position: IInfoGoPosition
    shareCloned: boolean
    intranet: boolean
    suppressed: boolean
    onIntranetCheck: (event: any) => void
    onSuppressCheck: (event: any) => void
    visible: boolean
    isDragging?: boolean
}

const PositionItem = (props: PositionItemProps) => {
    const { id, position, shareCloned, intranet, suppressed, onIntranetCheck, onSuppressCheck, visible, isDragging } = props
    const { isFrenchTranslator } = useAuth()
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id,  disabled: position.managementIndicator });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    }

    return (
        <div ref={setNodeRef}
            style={{ ...style, cursor: !position.managementIndicator && !isFrenchTranslator ? 'move' : 'inherit', opacity: isDragging && !isFrenchTranslator ? 0.5 : 1, visibility: visible ? 'visible' : 'visible' }}
            className="infogo-grid-row focus-ring"
            {...attributes}
            {...listeners} >
            <div className="infogo-pos-col1">
                {!position.managementIndicator ? <div style={{ marginTop: '-2px' }}><DnDIcon /></div> : <CrownIcon/>}
            </div>
            <div className="infogo-pos-col2" style={{fontWeight: position.managementIndicator ? 'bold' : 'normal'}}>
                {position.individualName ? position.individualName : 'Vacant'} - {position.positionName}
            </div>
            <div className="infogo-pos-col3">
               {!isFrenchTranslator && !shareCloned
                ?  <Input type="checkbox"
                        aria-label="intranet only"
                        checked={intranet}
                        onChange={onIntranetCheck}
                    />
                : <div>{intranet? <CheckMarkIcon title="Intranet only"></CheckMarkIcon>: <CancelIcon></CancelIcon>}</div>}
            </div>
            <div className="infogo-pos-col4">
                {!isFrenchTranslator &&<Input type="checkbox"
                    aria-label="suppress"
                    checked={suppressed}
                    onChange={onSuppressCheck}
                />}
                {isFrenchTranslator && <div>{suppressed? <CheckMarkIcon title="Suppressed"></CheckMarkIcon>: <CancelIcon></CancelIcon>}</div>}
            </div>

        </div>
    )
}

export default PositionItem
